"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
function arrBufToStr(buf, charSize) {
    var arr = charSize === 8 ? new Uint8Array(buf) : new Uint16Array(buf);
    return Array.from(arr)
        .map(function (b) { return String.fromCharCode(b); })
        .join('');
}
exports.arrBufToStr = arrBufToStr;
function arrBufToBase64(buf) {
    var str = arrBufToStr(buf, 8);
    return Buffer.from(str, 'binary').toString('base64');
}
exports.arrBufToBase64 = arrBufToBase64;
function strToArrBuf(str, charSize) {
    var view = charSize === 8 ? new Uint8Array(str.length) : new Uint16Array(str.length);
    for (var i = 0, strLen = str.length; i < strLen; i++) {
        view[i] = str.charCodeAt(i);
    }
    return view.buffer;
}
exports.strToArrBuf = strToArrBuf;
function base64ToArrBuf(base64) {
    var str = Buffer.from(base64, 'base64').toString('binary');
    return strToArrBuf(str, 8);
}
exports.base64ToArrBuf = base64ToArrBuf;
function publicExponent() {
    return new Uint8Array([0x01, 0x00, 0x01]);
}
exports.publicExponent = publicExponent;
function randomBuf(length) {
    var arr = new Uint8Array(length);
    globalThis.crypto.getRandomValues(arr);
    return arr.buffer;
}
exports.randomBuf = randomBuf;
function joinBufs(fst, snd) {
    var view1 = new Uint8Array(fst);
    var view2 = new Uint8Array(snd);
    var joined = new Uint8Array(view1.length + view2.length);
    joined.set(view1);
    joined.set(view2, view1.length);
    return joined.buffer;
}
exports.joinBufs = joinBufs;
exports.normalizeUtf8ToBuf = function (msg) {
    return exports.normalizeToBuf(msg, function (str) { return strToArrBuf(str, types_1.CharSize.B8); });
};
exports.normalizeUtf16ToBuf = function (msg) {
    return exports.normalizeToBuf(msg, function (str) { return strToArrBuf(str, types_1.CharSize.B16); });
};
exports.normalizeBase64ToBuf = function (msg) {
    return exports.normalizeToBuf(msg, base64ToArrBuf);
};
exports.normalizeUnicodeToBuf = function (msg, charSize) {
    switch (charSize) {
        case 8: return exports.normalizeUtf8ToBuf(msg);
        default: return exports.normalizeUtf16ToBuf(msg);
    }
};
exports.normalizeToBuf = function (msg, strConv) {
    if (typeof msg === 'string') {
        return strConv(msg);
    }
    else if (typeof msg === 'object' && msg.byteLength !== undefined) {
        // this is the best runtime check I could find for ArrayBuffer/Uint8Array
        var temp = new Uint8Array(msg);
        return temp.buffer;
    }
    else {
        throw new Error("Improper value. Must be a string, ArrayBuffer, Uint8Array");
    }
};
/* istanbul ignore next */
function structuralClone(obj) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    var _a = new MessageChannel(), port1 = _a.port1, port2 = _a.port2;
                    port2.onmessage = function (ev) { return resolve(ev.data); };
                    port1.postMessage(obj);
                })];
        });
    });
}
exports.structuralClone = structuralClone;
exports.default = {
    arrBufToStr: arrBufToStr,
    arrBufToBase64: arrBufToBase64,
    strToArrBuf: strToArrBuf,
    base64ToArrBuf: base64ToArrBuf,
    publicExponent: publicExponent,
    randomBuf: randomBuf,
    joinBufs: joinBufs,
    normalizeUtf8ToBuf: exports.normalizeUtf8ToBuf,
    normalizeUtf16ToBuf: exports.normalizeUtf16ToBuf,
    normalizeBase64ToBuf: exports.normalizeBase64ToBuf,
    normalizeToBuf: exports.normalizeToBuf,
    structuralClone: structuralClone
};
//# sourceMappingURL=utils.js.map